var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from 'react';
import Navigation from '@components/App/Navigation';
import { api } from '../../api/client';
export var Settings = function () {
    var _a = useState([]), tokens = _a[0], setTokens = _a[1];
    var _b = useState(''), name = _b[0], setName = _b[1];
    var _c = useState(null), justCreated = _c[0], setJustCreated = _c[1];
    var load = function () {
        api.listTokens().then(setTokens);
    };
    useEffect(function () {
        load();
    }, []);
    var create = function () { return __awaiter(void 0, void 0, void 0, function () {
        var token;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!name.trim())
                        return [2 /*return*/];
                    return [4 /*yield*/, api.createToken(name.trim())];
                case 1:
                    token = _a.sent();
                    setJustCreated(token);
                    setName('');
                    load();
                    return [2 /*return*/];
            }
        });
    }); };
    var remove = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.deleteToken(id)];
                case 1:
                    _a.sent();
                    load();
                    return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(React.Fragment, null,
        React.createElement(Navigation, { loggedIn: true }),
        React.createElement("div", { className: "max-w-2xl mx-auto sm:px-6 lg:px-8 py-10" },
            React.createElement("h1", { className: "text-lg font-medium text-gray-900 mb-2" }, "API tokens"),
            React.createElement("p", { className: "text-sm text-gray-600 mb-6" }, "Used by the browser extension (and any other client that can't do a browser OAuth login) to authenticate as you. Paste one into the extension's options page."),
            justCreated && (React.createElement("div", { className: "mb-6 p-4 bg-yellow-50 border border-yellow-200 rounded-md text-sm" },
                React.createElement("p", { className: "font-medium" }, "Copy this now - it won't be shown again:"),
                React.createElement("code", { className: "block mt-2 break-all" }, justCreated.value))),
            React.createElement("div", { className: "flex gap-2 mb-6" },
                React.createElement("input", { className: "flex-1 border border-gray-300 rounded-md shadow-sm p-2", placeholder: "e.g. browser extension", value: name, onChange: function (e) { return setName(e.target.value); } }),
                React.createElement("button", { onClick: create, className: "px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700" }, "Create token")),
            React.createElement("ul", { className: "divide-y divide-gray-200" }, tokens.map(function (t) { return (React.createElement("li", { key: t.id, className: "py-3 flex justify-between items-center" },
                React.createElement("div", null,
                    React.createElement("p", { className: "text-sm font-medium text-gray-900" }, t.name),
                    React.createElement("p", { className: "text-xs text-gray-500" },
                        "created ",
                        t.created_at)),
                React.createElement("button", { onClick: function () { return remove(t.id); }, className: "text-sm text-red-600 hover:text-red-900" }, "Revoke"))); })))));
};
export default Settings;
